module.exports = __webpack_public_path__ + "static/img/banner_06.08368fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner_06.jpg
// module id = VZcd
// module chunks = 9